import type { User } from "~types/user.ts";
import { DEFAULT_ROLE_CONFIG, userRolesConfig } from "../constants/userRolesConfig";
import type { PermissionProducts } from "../enums/permissionProducts";

const getUserProducts = (user: User): Set<PermissionProducts> | undefined => {
  const allPermissions = [...user.userBasedPermissions, ...user.roleBasedPermissions];

  if (allPermissions.length === 0) {
    return undefined;
  }

  const products = new Set<PermissionProducts>();

  for (const permission of allPermissions) {
    const config = userRolesConfig[permission.userRole] ?? DEFAULT_ROLE_CONFIG;
    products.add(config.product);
  }

  return products;
};

export default getUserProducts;
